import { render, staticRenderFns } from "./EWUserLimitConfigShow.vue?vue&type=template&id=105df84f&"
import script from "./EWUserLimitConfigShow.vue?vue&type=script&lang=js&"
export * from "./EWUserLimitConfigShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports